<template>
  <div class="product-search-widget">
    <PopupSearchWidget
      ref="searchWidget"
      :title="$t('product.search')"
      :width="800"
      :action="handleSearch"
      :columns="columns"
      :selectedRowTitle="productName"
      :selectedRowId="productId"
      :defaultData="products"
      :disabled="disabled"
      @on-select="handleChanged"
    ></PopupSearchWidget>
  </div>
</template>

<script>
import { eloquentsearch } from '@/api/search'
import PopupSearchWidget from '@/components/search/popup-select-widget'
export default {
  name: 'ProductSearchWidget',
  props: {
    product: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PopupSearchWidget
  },
  data() {
    return {
      columns: [
        { type: 'radio', field: 'id', title: 'ID', width: 80 },
        { field: 'product_name', title: 'Name', width: 250, remoteSort: false },
        { field: 'product_type', title: 'Type', width: 90, remoteSort: false },
        { field: 'model', title: 'Model', width: 200, remoteSort: false },
        { field: 'erp_id', title: 'Part number', width: 120, remoteSort: false }
      ]
    }
  },
  computed: {
    products: function () {
      return this.product ? [this.product] : []
    },
    productName: function () {
      let name = this.product ? this.product.product_name : null

      if (name && this.product.product_number) {
        name = name + ` (${this.product.product_number})`
      }
      return name
    },
    productId: function () {
      return this.product ? this.product.id : null
    }
  },
  mounted () {
  },
  methods: {
    async handleSearch (keyword) {
      let result = await eloquentsearch('product', encodeURIComponent(keyword))
      return result && result.data ? result.data.data : []
    },
    handleChanged(product) {
      this.$emit('update:product', product)
      this.$emit('on-changed', product)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
